import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-angle-right",
  "use": "icon-angle-right-usage",
  "viewBox": "0 0 8 15",
  "content": "<symbol viewBox=\"0 0 8 15\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-angle-right\">\n<path d=\"M0.999454 0.7525C0.809454 0.7525 0.619454 0.822499 0.469454 0.972499C0.179454 1.2625 0.179454 1.7425 0.469454 2.0325L5.93945 7.5025L0.469453 12.9725C0.179453 13.2625 0.179453 13.7425 0.469453 14.0325C0.759453 14.3225 1.23945 14.3225 1.52945 14.0325L7.52945 8.0325C7.81945 7.7425 7.81945 7.2625 7.52945 6.9725L1.52945 0.972499C1.37945 0.822499 1.18945 0.7525 0.999454 0.7525Z\" fill=\"#C0C0C0\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol